import React from 'react';
import {
  FunctionField,
  Labeled,
  RecordContextProvider,
  useGetOne,
  useRecordContext,
} from 'react-admin';

const PoolPositions = ({ id }: { id: number }) => {
  const { data: pool } = useGetOne('Pool', { id });

  return (
    <RecordContextProvider value={pool}>
      <Labeled label="Pool Position(s)">
        <FunctionField
          render={(record) => record?.positions?.map((item) => item.display_name).join(', ')}
        />
      </Labeled>
    </RecordContextProvider>
  );
};

export const PoolPositionsField = () => {
  const poolPq = useRecordContext();
  const poolPqa = poolPq?.admin_professional_qualification_attributes?.find(
    (attr) => attr.qualification_attribute?.slug === 'pro_pool_pool_id',
  );
  const poolId = poolPqa?.value;

  if (!poolId) {
    return null;
  }

  return <PoolPositions id={poolId} />;
};
